export enum ServiceStatus {
  NEW = 'NEW',

  SUCCESS = 'SUCCESS',

  UNSUCCESS = 'UNSUCCESS',
}
